var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14197",
    "data-name": "Group 14197",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2859",
    "data-name": "Rectangle 2859",
    width: 20,
    height: 20,
    fill: "#0d162f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13280",
    "data-name": "Group 13280",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12942",
    "data-name": "Path 12942",
    d: "M18.5,18.5H1.5V1.5h17ZM19,0H1A1,1,0,0,0,0,1V19a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V1a1,1,0,0,0-1-1",
    fill: "#0d162f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2856",
    "data-name": "Rectangle 2856",
    width: 2,
    height: 4,
    rx: 1,
    transform: "translate(4.25 12.5)",
    fill: "#0d162f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2857",
    "data-name": "Rectangle 2857",
    width: 2,
    height: 8,
    rx: 1,
    transform: "translate(9 8.5)",
    fill: "#0d162f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2858",
    "data-name": "Rectangle 2858",
    width: 2,
    height: 13,
    rx: 1,
    transform: "translate(13.75 3.5)",
    fill: "#0d162f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.da7e9ded9e68798083d2083ebe605f1a.svg";
export { ForwardRef as ReactComponent };